import AdminBarChart from './component'

export default AdminBarChart
